var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"site-header"},[_c('div',{staticClass:"site-header__content"},[(_vm.currentScrollY < _vm.windowHeight)?_c('img',{staticClass:"site-header__logo",style:([_vm.getExpandedStyle()]),attrs:{"src":require("../assets/images/logo-hug-gruppe.svg"),"alt":"Logo Hug Gruppe"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }